<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-col>
                <b-row no-gutters>
                    <span class="badge badge-primary">Emitente</span>
                </b-row>
            </b-col>
            <b-col>
                <b-row no-gutters>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">CNPJ</label>
                        <b-form-input type="text"
                                     placeholder="CNPJ"
                                     v-model="form.emi_cnpj"
                                     name="emi_cnpj">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_cnpj')" v-if="form.errors.has('emi_cnpj')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">IE</label>
                        <b-form-input type="text"
                                     placeholder="IE"
                                     v-model="form.emi_ie"
                                     name="emi_ie">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_ie')" v-if="form.errors.has('emi_ie')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">Nome</label>
                        <b-form-input type="text"
                                     placeholder="Nome"
                                     v-model="form.emi_nome"
                                     name="emi_nome">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_nome')" v-if="form.errors.has('emi_nome')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1"  class="p-0">
                        <label tag="div">Município</label>
                        <b-form-input type="text"
                                     placeholder="Município"
                                     v-model="form.emi_nome_municipio"
                                     name="emi_nome_municipio">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_nome_municipio')" v-if="form.errors.has('emi_nome_municipio')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">UF</label>
                        <b-form-input type="text"
                                     placeholder="UF"
                                     v-model="form.emi_uf"
                                     name="emi_uf">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_uf')" v-if="form.errors.has('emi_uf')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1"  class="p-0">
                        <label tag="div">Endereço</label>
                        <b-form-input type="text"
                                     placeholder="Endereço"
                                     v-model="form.emi_endereco"
                                     name="emi_endereco">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_endereco')" v-if="form.errors.has('emi_endereco')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">Complemento</label>
                        <b-form-input type="text"
                                     placeholder="Complemento"
                                     v-model="form.emi_complemento"
                                     name="emi_complemento">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_complemento')" v-if="form.errors.has('emi_complemento')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label  tag="div">Número</label>
                        <b-form-input type="text"
                                     placeholder="Número"
                                     v-model="form.emi_numero"
                                     name="emi_numero">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_numero')" v-if="form.errors.has('emi_numero')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">Bairro</label>
                        <b-form-input type="text"
                                     placeholder="Bairro"
                                     v-model="form.emi_bairro"
                                     name="emi_bairro">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_bairro')" v-if="form.errors.has('emi_bairro')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">CEP</label>
                        <b-form-input type="text"
                                     placeholder="CEP"
                                     v-model="form.emi_cep"
                                     name="emi_cep">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_cep')" v-if="form.errors.has('emi_cep')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">Tel.</label>
                        <b-form-input type="text"
                                     placeholder="Tel."
                                     v-model="form.emi_telefone"
                                     name="emi_telefone">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('emi_telefone')" v-if="form.errors.has('emi_telefone')"></b-form-feedback>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="pt-1">
                <b-row no-gutters>
                    <span class="badge badge-success">Destinatário</span>
                </b-row>
            </b-col>
            <b-col>
                <b-row no-gutters>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">CNPJ</label>
                        <b-form-input type="text"
                                     placeholder="CNPJ"
                                     v-model="form.des_cnpj"
                                     name="des_cnpj">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_cnpj')" v-if="form.errors.has('des_cnpj')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">IE</label>
                        <b-form-input type="text"
                                     placeholder="IE"
                                     v-model="form.des_ie"
                                     name="des_ie">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_ie')" v-if="form.errors.has('des_ie')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">Nome</label>
                        <b-form-input type="text"
                                     placeholder="Nome"
                                     v-model="form.des_nome"
                                     name="des_nome">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_nome')" v-if="form.errors.has('des_nome')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1"  class="p-0">
                        <label tag="div">Município</label>
                        <b-form-input type="text"
                                     placeholder="Município"
                                     v-model="form.des_nome_municipio"
                                     name="des_nome_municipio">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_nome_municipio')" v-if="form.errors.has('des_nome_municipio')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">UF</label>
                        <b-form-input type="text"
                                     placeholder="UF"
                                     v-model="form.des_uf"
                                     name="des_uf">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_uf')" v-if="form.errors.has('des_uf')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1"  class="p-0">
                        <label tag="div">Endereço</label>
                        <b-form-input type="text"
                                     placeholder="Endereço"
                                     v-model="form.des_endereco"
                                     name="des_endereco">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_endereco')" v-if="form.errors.has('des_endereco')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">Complemento</label>
                        <b-form-input type="text"
                                     placeholder="Complemento"
                                     v-model="form.des_complemento"
                                     name="des_complemento">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_complemento')" v-if="form.errors.has('des_complemento')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label  tag="div">Número</label>
                        <b-form-input type="text"
                                     placeholder="Número"
                                     v-model="form.des_numero"
                                     name="des_numero">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_numero')" v-if="form.errors.has('des_numero')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">Bairro</label>
                        <b-form-input type="text"
                                     placeholder="Bairro"
                                     v-model="form.des_bairro"
                                     name="des_bairro">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_bairro')" v-if="form.errors.has('des_bairro')"></b-form-feedback>
                    </b-col>
                    <b-col md="1" sm="1" class="p-0">
                        <label tag="div">CEP</label>
                        <b-form-input type="text"
                                     placeholder="CEP"
                                     v-model="form.des_cep"
                                     name="des_cep">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_cep')" v-if="form.errors.has('des_cep')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">E-mail</label>
                        <b-form-input type="text"
                                     placeholder="E-mail"
                                     v-model="form.des_email"
                                     name="des_email">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_email')" v-if="form.errors.has('des_email')"></b-form-feedback>
                    </b-col>
                    <b-col  md="1" sm="1" class="p-0">
                        <label tag="div">Tel.</label>
                        <b-form-input type="text"
                                     placeholder="Tel."
                                     v-model="form.des_telefone"
                                     name="des_telefone">
                        </b-form-input>
                        <b-form-feedback v-text="form.errors.get('des_telefone')" v-if="form.errors.has('des_telefone')"></b-form-feedback>
                    </b-col>
                </b-row>
            </b-col>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      form: new Form({
            emi_cnpj: '',
            emi_nome: '',
            emi_ie: '',
            emi_nome_municipio: '',
            emi_uf: '',
            emi_endereco: '',
            emi_complemento: '',
            emi_numero: '',
            emi_bairro: '',
            emi_cep: '',
            emi_email: '',
            emi_telefone: '',
            des_cnpj: '',
            des_nome: '',
            des_ie: '',
            des_nome_municipio: '',
            des_uf: '',
            des_endereco: '',
            des_complemento: '',
            des_numero: '',
            des_bairro: '',
            des_cep: '',
            des_email: '',
            des_telefone: '',
            dofipaen_id: '',
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
     fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.dofipaen_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onEdit (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.emi_cnpj              = data.emiCnpj;
      this.form.emi_nome              = data.emiNome;
      this.form.emi_ie                = data.emiIe;
      this.form.emi_nome_municipio    = data.emiNomeMunicipio;
      this.form.emi_uf                = data.emiUf;
      this.form.emi_endereco          = data.emiEndereco;
      this.form.emi_complemento       = data.emiComplemento;
      this.form.emi_numero            = data.emiNumero;
      this.form.emi_bairro            = data.emiBairro;
      this.form.emi_cep               = data.emiCep;
      this.form.emi_telefone          = data.emiTelefone;
      this.form.des_cnpj              = data.desCnpj;
      this.form.des_nome              = data.desNome;
      this.form.des_ie                = data.desIe;
      this.form.des_nome_municipio    = data.desNomeMunicipio;
      this.form.des_uf                = data.desUf;
      this.form.des_endereco          = data.desEndereco;
      this.form.des_complemento       = data.desComplemento;
      this.form.des_numero            = data.desNumero;
      this.form.des_bairro            = data.desBairro;
      this.form.des_cep               = data.desCep;
      this.form.des_email             = data.desEmail;
      this.form.des_telefone          = data.desTelefone;
      this.form.dofipaen_id           = data.dofipaenId;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/montagemcarga/partesenv/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });

    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
